module.exports = __webpack_public_path__ + "assets/icons/translated_with_DeepL_IT-4ab4.svg";